(function () {

  function getSwiperOpts(slider) {
    return {
      pagination: {
        el: slider.querySelector(".product-pagination .swiper-pagination"),
        clickable: true,
      },
      navigation: {
        nextEl: slider.querySelector(".product-button-group.button-next .swiper-button-next"),
        prevEl: slider.querySelector(".product-button-group.button-prev .swiper-button-prev"),
      },
      allowTouchMove: true,
      breakpoints: {
        990: { allowTouchMove: false },
      },
    };
  }

  function initSlider() {
    document.querySelectorAll(".product-card-js:not(.swiper-initialized)").forEach(function (slider) {
      new Swiper(slider, getSwiperOpts(slider));
    });
  }

  initSlider();

  document.addEventListener("shopify:section:load", function () {
    initSlider();
  });

})();